import "./gallery-card.scss";
